"use client";

import * as React from 'react';
import Base from './Base';
const Paragraph = /*#__PURE__*/React.forwardRef((props, ref) => (/*#__PURE__*/React.createElement(Base, Object.assign({
  ref: ref
}, props, {
  component: "div"
}))));
export default Paragraph;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/typography/Paragraph.js
// module id = 3753
// module chunks = 0